import React, { Component } from 'react'
import ErrorFlyerManager from '../_middleware/errors/screens/ErrorFlyerManager'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log('Flyer Manager error: ', { error, errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFlyerManager />
    }

    return this.props.children
  }
}

export default ErrorBoundary
